import React from 'react';

import { FormattedMessage } from '../../../../util/reactIntl';

import { NamedLink } from '../../../../components';

import css from './Disciplines.module.css';

const specialties = [
  { id: 'newbornCare', label: 'Newborn care' },
  { id: 'doula', label: 'Doula' },
  { id: 'lactation', label: 'Lactation' },
  { id: 'pelvicFloor', label: 'Pelvic floor' },
  { id: 'mentalHealth', label: 'Mental health' },
  { id: 'massage', label: 'Massage + Lymphatic' },
  { id: 'nutrition', label: 'Nutrition' },
  { id: 'fitness', label: 'Fitness' },
  { id: 'nursePractitioner', label: 'Nurse practitioner' },
  { id: 'bellyBinding', label: 'Belly binding' },
  { id: 'infantCpr', label: 'Infant CPR' },
  { id: 'chiropractic', label: 'Chiropractic' },
];

/**
 * Disciplines the platform is built for, with an invitation to apply outside the list.
 */
const Disciplines = () => (
  <section className={css.root}>
    <div className={css.inner}>
      <p className={css.eyebrow}>
        <FormattedMessage id="ForProvidersDisciplines.eyebrow" defaultMessage="Who it's for" />
      </p>
      <h2 className={css.title}>
        <FormattedMessage
          id="ForProvidersDisciplines.title"
          defaultMessage="All perinatal care disciplines"
        />
      </h2>
      <ul className={css.list}>
        {specialties.map(specialty => (
          <li key={specialty.id} className={css.item}>
            <FormattedMessage
              id={`ForProvidersDisciplines.${specialty.id}`}
              defaultMessage={specialty.label}
            />
          </li>
        ))}
      </ul>
      <p className={css.note}>
        <FormattedMessage
          id="ForProvidersDisciplines.note"
          defaultMessage="Practice a different discipline? If your services support families through pregnancy, postpartum, or early parenthood, <apply>you should still apply</apply>."
          values={{
            apply: chunks => (
              <NamedLink
                className={css.apply}
                name="SignupForUserTypePage"
                params={{ userType: 'provider' }}
              >
                {chunks}
              </NamedLink>
            ),
          }}
        />
      </p>
    </div>
  </section>
);

export default Disciplines;
